/**
 * Dev-only console logging. Swapped in for direct `console.error/log/warn` calls
 * so production builds don't expose internal error text to end users.
 *
 * `NODE_ENV` is set to `'production'` by CRA/react-scripts on `yarn build`,
 * and `'development'` on `yarn start`.
 */
const isDev = process.env.NODE_ENV !== 'production';

export const devError = (...args) => {
  if (isDev) console.error(...args);
};

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const devLog = (...args) => {
  if (isDev) console.log(...args);
};
